// mds-dojo — dojo/regexp: escapeString (+ the group helpers dojo shipped).

export function escapeString(str: string, except?: string): string {
  return str.replace(/([\.$?*|{}\(\)\[\]\\\/\+\-^])/g, (ch) => {
    if (except && except.indexOf(ch) !== -1) { return ch; }
    return '\\' + ch;
  });
}

export function buildGroupRE(arr: any, re: (item: any) => string, nonCapture?: boolean): string {
  if (!(arr instanceof Array)) { return re(arr); }
  const b = arr.map(re);
  return group(b.join('|'), nonCapture);
}

export function group(expression: string, nonCapture?: boolean): string {
  return '(' + (nonCapture ? '?:' : '') + expression + ')';
}

const regexp = { escapeString, buildGroupRE, group };
export default regexp;
